module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p2-3237c7203720f9ea32169260db05d3db.png";